import { AssetWizardFlow } from '@/store/ai/assetWizard/utils/types'

import { fineArtWizard } from '../FineArt'
import { loanWizard } from '../Loan'
import { privateFundWizard } from '../PrivateFund'
import { privateFundSubscribeAndCommitWizard } from '../PrivateFundSubscribeAndCommit'
import { privateSecurityWizard } from '../PrivateSecurity'
import { realEstateWizard } from '../RealEstate'
import { realEstateWithFinancingWizard } from '../RealEstateWithFinancing'
import { vehicleWizard } from '../Vehicle'

import { WizardDefinition } from './types'

/**
 * Flow → the wizard that collects it.
 *
 * The one place the assistant's answer becomes a screen. Every flow the backend
 * can name has an entry, which is what makes the mapping exhaustive rather than
 * a lookup that can miss: `AssetWizardFlow` and this record are changed
 * together or TypeScript objects.
 *
 * To add a wizard: add the flow to `AssetWizardFlow` (and to the backend's
 * `AssetWizardFlow` / `ASSET_WIZARD_FLOW_FIELDS`, or the assistant can never
 * choose it), then a folder beside this one holding `schema.ts` (zod),
 * `index.ts` (steps and records, built from `utils/fields` and `utils/steps`)
 * and `create.ts` (what it writes, built from `utils/create`), and register it
 * here. Wizard.vue renders whatever the definition says; a step the field grid
 * cannot express names its own `component`, as the mortgage step does.
 */
export const WIZARD_BY_FLOW: Record<AssetWizardFlow, WizardDefinition> = {
  [AssetWizardFlow.PRIVATE_FUND]: privateFundWizard,
  [AssetWizardFlow.PRIVATE_FUND_SUBSCRIBE_AND_COMMIT]: privateFundSubscribeAndCommitWizard,
  [AssetWizardFlow.REAL_ESTATE]: realEstateWizard,
  [AssetWizardFlow.REAL_ESTATE_WITH_FINANCING]: realEstateWithFinancingWizard,
  [AssetWizardFlow.LOAN]: loanWizard,
  [AssetWizardFlow.FINE_ART]: fineArtWizard,
  [AssetWizardFlow.VEHICLE]: vehicleWizard,
  [AssetWizardFlow.PRIVATE_SECURITY]: privateSecurityWizard,
}

/** Every flow, in the order they are offered. */
export const WIZARD_FLOWS = Object.values(AssetWizardFlow)
